// @vue/component
export default {
  name: 'BlacklistOperationForm',

  props: {
    projectList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      blacklistElementForm: {
        blocked_num: '',
        project: '',
      },
      rules: {
        blocked_num: [
          { required: true, message: 'Pole jest wymanage', trigger: 'blur' },
          { type: 'number', message: 'Musisz wpisać numer', trigger: 'blur' },
        ],
        project: [
          { required: true, message: 'Pole jest wymanage', trigger: 'blur' },
        ],
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'blacklist/createNumber',
        'blacklist/getList']);
    },
  },

  methods: {
    cancelForm() {
      this.$refs.blacklistElementForm.resetFields();
      this.$emit('closeModal');
    },
    submitForm() {
      this.$refs.blacklistElementForm.validate(async (valid) => {
        if (valid) {
          await this.$store.dispatch('blacklist/createNumber', this.blacklistElementForm);
          this.$message({
            type: 'success',
            message: `Numer ${this.blacklistElementForm.blocked_num} został dopisany do czarnej listy`,
          });

          this.$emit('refreshList');
          this.$emit('closeModal');
        }
      });
    },
  },

};
